import { useTranslation } from '@nextgen-web-framework/all';
import { FC } from 'react';
import FeatureProduct from '../feature-product/FeatureProduct';
import FeatureProductButton from '../feature-product-button/FeatureProductButton';
import styles from './FeatureProductLanding.module.scss';
import type { FeatureProductLandingProps } from './types/propTypes';
const FeatureProductLanding: FC<FeatureProductLandingProps> = ({
  featureProductIds,
  selectedFeatureProducts,
  maxAllowableSelection,
  isReceiver,
  version,
}: FeatureProductLandingProps): JSX.Element => {
  let selection: string[] = [];

  if (selectedFeatureProducts && selectedFeatureProducts.length > 0) {
    selection = featureProductIds.map((id) => id.trim()).filter((m) => selectedFeatureProducts.includes(m));
  }

  const t = useTranslation();
  return (
    <div className={styles['feature-product-landing-container']} data-testid="feature-product-landing-testid">
      <div className={styles['feature-product-landing-content-container']}>
        <div className={styles['feature-product-title-action']}>
          <div className={styles['feature-product-landing-title']}>{t('myshop.ShopLanding.FeatureProductTitle')}</div>
          {!isReceiver && selectedFeatureProducts && selectedFeatureProducts.length > 0 && (
            <FeatureProductButton
              maxAllowableSelection={maxAllowableSelection}
              availableProductIds={featureProductIds}
              selectedProducts={selectedFeatureProducts}
              version={version}
            />
          )}
        </div>
        {!isReceiver && selectedFeatureProducts && selectedFeatureProducts.length === 0 && (
          <div className={styles['feature-product-landing-description']}>
            {t('myshop.ShopLanding.FeatureProductDescription').replace('{0}', maxAllowableSelection.toString())}
          </div>
        )}
      </div>
      {selectedFeatureProducts && selectedFeatureProducts.length > 0 ? (
        <FeatureProduct featureProductIds={selection} isReceiver={isReceiver} />
      ) : (
        !isReceiver && (
          <FeatureProductButton
            maxAllowableSelection={maxAllowableSelection}
            availableProductIds={featureProductIds}
            version={version}
          />
        )
      )}
    </div>
  );
};

export default FeatureProductLanding;
